import { render, staticRenderFns } from "./PushNotificationCenter.vue?vue&type=template&id=3a8c791b&"
import script from "./PushNotificationCenter.vue?vue&type=script&lang=js&"
export * from "./PushNotificationCenter.vue?vue&type=script&lang=js&"
import style0 from "./PushNotificationCenter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports